<template>
  <div class="myinfo">
    <div class="form-horizontal myform">
      <div class="input-group">
        <span class="input-group-addon border"><i class="iconfont icon-shouji"></i></span>
        <input type="text" class="form-control" placeholder="请输入手机号" aria-describedby="basic-addon1" v-model="phone" />
      </div>
      <div class="input-group" v-if="archives.length >= 2">
        <span class="input-group-addon border"><i class="iconfont icon-shouji"></i></span>
        <select class="form-control select" @change="change($event)">
          <option v-for="item in archives" :key="item.id" :value="item.id">
            {{ item.eduName }}-{{item.grade}}-{{item.proName}}
          </option>
        </select>
      </div>
      <div class="input-group">
        <span class="input-group-addon"><i class="iconfont icon-anquanxing"></i></span>
        <input type="text" class="form-control" placeholder="请输入图形验证码" aria-describedby="basic-addon1" v-model="captcha" />
        <button type="submit" class="btn btn-default form-control sub" @click="getRandomImage" v-if="!imageCode">获取验证码</button>
        <img :src="imageCode" v-else @click="getRandomImage" />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><i class="iconfont icon-anquanxing"></i></span>
        <a-input type="text" style="height: 35.75px" class="form-control" placeholder="请输入短信验证码"
                 aria-describedby="basic-addon1" v-model="sms" @pressEnter="submit" />
        <button type="submit" class="btn btn-default form-control sub" @click="getSms" :disabled="smsDisabled">
          {{ smsMessage }}
        </button>
      </div>
      <div class="agreement">
        <a-checkbox :checked="acceptCheck" @change="onCheckChange">阅读并同意<span class="clickText" @mousedown.prevent @click.stop="handleUserAgree">用户协议</span>和<span class="clickText" @mousedown.prevent @click.stop="handlePrivacyPolicy">隐私政策</span></a-checkbox>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <a-spin :spinning="submitSpinning">
            <!-- 手机验证码登录提交 -->
            <button type="submit" @click="submit" class="btn btn-default form-control sub">登录</button>
          </a-spin>
        </div>
      </div>
      <div class="pull-right">
        <router-link to="/findpwd">忘记密码</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: 'zuaViewState',
  props: {
    acceptCheck: {
      type: Boolean,
      default: false
    },
    changeAcceptCheck: {
      type: Function,
      default: () => {}
    }
  },
  data: function () {
    return {
      randomCode: null,
      imageCode: `/static/images/checkcode.png`,
      uuid: null,
      captcha: '',
      phone: '',
      sms: '',
      archives: [],
      userid: null,
      smsDisabled: false,
      submitSpinning: false,
      timer: null,
      smsMessage: `获取短信验证码`
    }
  },
  mounted() {
    const number = parseInt(Math.random(1) * Math.pow(10, 10))
    this.randomCode = number
    this.getRandomImage() // 获取图形验证码
  },
  methods: {
    change(e) {
      this.userid = e.target.value
    },
    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        this.imageCode = res.result
      })
    },
    usernameBlur() {
      this.axios
          .get(`/sys/archives/zuaPhone`, {
            params: {
              phone: this.phone
            }
          })
          .then((res) => {
            this.archives = res.result
            if (res.result.length > 1) {
              this.userid = res.result[0].id
              this.sendSms()
            } else if (res.result.length === 1) {
              this.userid = res.result[0].id
              this.sendSms()
            } else {
              this.$error({
                title: '',
                content: (
                    <div>
                      <span style="font-size:16px;font-weight:550;">当前手机号暂未绑定平台账号</span><br />
                      <span>如何绑定？</span><br />
                      <span>使用账号密码登录后，进入个人中心-安全中心-绑定手机号根据提示进行绑定。</span>
                    </div>
                )
              })
            }
          })
    },
    getSms() {
      if (!this.captcha) {
        this.$message.warning('请输入验证码')
        return
      }
      this.usernameBlur()
    },
    countdown(index) {
      let countdownData = index
      this.smsDisabled = true

      if (this.timer) {
        clearInterval(this.timer)
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`
          countdownData--
        } else {
          this.smsMessage = `获取短信验证码`
          this.smsDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    sendSms() {
      this.axios
          .post(`/sys/sms`, {
            captcha: this.captcha,
            checkKey: this.randomCode,
            mobile: this.phone
          })
          .then((res) => {
            if (res.success) {
              this.$message.success('发送成功')
              this.countdown(300)
            } else {
              this.getRandomImage()
            }
          })
          .catch(() => {
            this.getRandomImage()
          })
    },
    submit() {
      if (!this.acceptCheck) {
        this.$message.error('请同意用户协议和隐私政策')

      } else if(null == this.userid){
        this.$message.warning('未获取短信验证码')
      }else if (!this.sms) {
        this.$message.warning('请输入短信验证码')

      }else if (!this.phone) {
        this.$message.warning('请输入手机号')

      }else{
        this.submitSpinning = true
        this.axios
            .post(`/sys/phone/login/zuaPc`, {
              captcha: this.sms,
              checkKey: this.randomCode,
              devideId: '',
              devideType: 0,
              mobile: this.phone,
              password: '',
              userid: this.userid,
              username: '',
              uuid: '',
              wxAvatar: '',
              wxCode: '',
              wxNickName: ''
            })
            .then((res) => {
              if(res.result.loginType == 1){
                if (res.result.userInfo && res.result.token) {
                  let userInfo = res.result.userInfo
                  if(userInfo.eduCode != '125'){
                    Cookies.remove('loginType')
                  }
                  userInfo.eduHomeUrl = res.result.eduHomeUrl || null
                  userInfo.eduLogo = res.result.eduLogo || null
                  this.common.loginSuccess(res.result.token, userInfo)
                }
              }else{
                if(res.success){
                  if(res.result.userInfo.eduCode != '125'){
                    Cookies.remove('loginType')
                  }
                  window.location.href = process.env.admHost + "/unifyLogin?token=" + res.result.token
                }
              }
              this.submitSpinning = false
            })
            .catch(() => {
              this.submitSpinning = false
            })
      }
    },
    onCheckChange() {
      this.$emit('changeAcceptCheck')
    },
    handleUserAgree(event) {
      event.preventDefault()
      window.open(
          'https://app.jxjypt.cn/yhxy.html',
          '_blank'
      )
    },
    handlePrivacyPolicy(event) {
      event.preventDefault()
      window.open(
          'https://app.jxjypt.cn/yszc.html',
          '_blank'
      )
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  padding: 28px;
  margin-top: 20px;
}

.clickText {
  color: #1890ff;
  margin-left: 2px;
  margin-right: 2px;
}

.agreement {
  margin-bottom: 10px;
  font-size: 12px;
  color: #999;
}

.myform {
  width: 440px;
  margin: 0 auto;
  background: none;

  .input-group {
    margin-bottom: 20px;
  }

  .input-group-addon {
    display: inline-block;
    width: 38px;
    text-align: center;
    background: #eaeaea;
    line-height: 33px;
    color: #fff;
  }

  .sub {
    background: $bgColor;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/components/zuaViewStatus.vue